import React from 'react';

import useSigninRedirect from './hooks';

const SigninRedirect = (): React.JSX.Element => {
  useSigninRedirect();
  return <></>;
};

export default SigninRedirect;
